import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}city-fresh`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const cityFreshApi = {
  getTotalAmountPaid: (request) => {
    const { config } = request
    return instance().get(`/sum-paid`, config)
  }
}
export default cityFreshApi



// WEBPACK FOOTER //
// ./src/api/city-fresh.js